module.exports = __webpack_public_path__ + "media/andenes/minidock_ohd-523fe6eb.webp";